import { httpsCallable } from 'firebase/functions';
import { functions } from '@/core/firebase';
import type { WorkoutTemplate } from '../types';

interface StartAdHocWorkoutSessionArgs {
  template: WorkoutTemplate;
  clientId: string;
  trainerId: string;
  sessionType?: 'daily' | 'ad_hoc';
}

interface StartAdHocWorkoutSessionResponse {
  success: boolean;
  sessionId: string;
  status: 'in_progress';
}

export async function startAdHocWorkoutSession({
  template,
  sessionType = 'ad_hoc',
}: StartAdHocWorkoutSessionArgs) {
  const startAdHocWorkoutSessionFn = httpsCallable<
    { templateId: string; sessionType: 'daily' | 'ad_hoc' },
    StartAdHocWorkoutSessionResponse
  >(functions, 'startAdHocWorkoutSession');

  const result = await startAdHocWorkoutSessionFn({
    templateId: template.id,
    sessionType,
  });

  return { id: result.data.sessionId };
}
